// extracted by mini-css-extract-plugin
module.exports = {"video":"styles_video__y1jL9","title":"styles_title__H9tS3","content":"styles_content__3X2RF","overlay":"styles_overlay__MxQ_b"};